enum TokenConstants {
  NR_SEQ_WSUITE_USER = 'ext_nrSeqUser',
  NR_SEQ_PLS_USER = 'ext_nrSeqPlsUser',
  DEFAULT_PROVIDER = 'ext_default_provider',
  EXT_SSO_LOGIN = 'ext_sso_login',
  EXT_SSO_LOGOUT_ROUTE = 'ext_sso_logout',
}

export default TokenConstants;
